import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICrisisActions, IThunkEditCrisisAllocation } from '../types';

const onEditCrisisAllocation: IThunkEditCrisisAllocation = thunk(
  async ({ setCrisisAllocation }: Actions<ICrisisActions>, { clinicId, id, memo }) => {
    const crisisAllocation = await api.crisis
      .editCrisisAllocation(clinicId, id, memo)
      .then(r => r.data);

    setCrisisAllocation(crisisAllocation);

    return crisisAllocation;
  },
);

export default onEditCrisisAllocation;
